<template>
    <div :class="warningClass">
        <common-icon name="white-warning" size="medium-large"></common-icon>
        <span :class="`warning__text-${size}`">{{ text }}</span>
    </div>
</template>
<script>
    export default {
        props: {
            text: { type: String, required: true },
            size: { type: String, required: true },
            isCenter: { type: Boolean, default: false },
        },

        computed: {
            warningClass() {
                return {
                    warning: true,
                    warning__center: this.isCenter,
                }
            },
        },
    }
</script>
